export default __webpack_public_path__ + "static/features_onboarding-5d24d3db157c6604cb80e9b0eedf46a8.webp";